/* eslint-disable @typescript-eslint/no-explicit-any */
import { GridColDef } from "@mui/x-data-grid";
import EditIcon from "@mui/icons-material/Edit";
import GroupIcon from "@mui/icons-material/Group";
import { Button, Chip, Tooltip } from "@mui/material";
import { ClientScoringRule } from "./types";

const getColumns = ({
  onEdit,
  onManageClients,
}: {
  onEdit: (row: ClientScoringRule) => void;
  onManageClients: (row: ClientScoringRule) => void;
}): GridColDef[] => [
  {
    field: "id",
    headerName: "ID",
    width: 80,
    valueGetter: (value, row: ClientScoringRule) => row.scoringRule.id,
  },
  {
    field: "ruleType",
    headerName: "Rule Type",
    flex: 1,
    minWidth: 150,
    valueGetter: (value, row: ClientScoringRule) => row.scoringRule.ruleType,
  },
  {
    field: "description",
    headerName: "Description",
    flex: 2,
    minWidth: 200,
    valueGetter: (value, row: ClientScoringRule) => row.scoringRule.description,
  },

  {
    field: "score",
    headerName: "Score",
    width: 100,
    align: "center",
    headerAlign: "center",
    valueGetter: (value, row: ClientScoringRule) => row.scoringRule.score,
  },
  {
    field: "ruleEnabled",
    headerName: "Rule Enabled",
    width: 130,
    align: "center",
    headerAlign: "center",
    valueGetter: (value, row: ClientScoringRule) => row.scoringRule.enabled,
    valueFormatter: (value) => (value ? "Enabled" : "Disabled"),
    renderCell: (params) => (
      <Chip
        label={params.value ? "Enabled" : "Disabled"}
        color={params.value ? "success" : "default"}
        size="small"
      />
    ),
  },
  {
    field: "clientEnabled",
    headerName: "Client Enabled",
    width: 150,
    align: "center",
    headerAlign: "center",
    valueGetter: (value, row: ClientScoringRule) => !row.disabled,
    valueFormatter: (value) => (value ? "Enabled" : "Disabled"),
    renderCell: (params) => (
      <Chip
        label={params.value ? "Enabled" : "Disabled"}
        color={params.value ? "success" : "error"}
        size="small"
      />
    ),
  },
  {
    field: "actions",
    type: "actions",
    headerName: "Actions",
    width: 140,
    align: "right",
    getActions: ({ row }: { row: ClientScoringRule }) => [
      <Tooltip key="manage-clients" title="Manage clients for this rule">
        <Button
          aria-label="manage clients"
          onClick={(e: any) => {
            e.stopPropagation();
            onManageClients(row);
          }}
        >
          <GroupIcon fontSize="small" />
        </Button>
      </Tooltip>,
      <Tooltip key="edit" title="Edit rule for this client">
        <Button
          aria-label="edit"
          onClick={(e: any) => {
            e.stopPropagation();
            onEdit(row);
          }}
        >
          <EditIcon fontSize="small" />
        </Button>
      </Tooltip>,
    ],
  },
];

export default getColumns;
